import { render, staticRenderFns } from "./updateOrg.vue?vue&type=template&id=25cae8b5&scoped=true&"
import script from "./updateOrg.vue?vue&type=script&lang=js&"
export * from "./updateOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cae8b5",
  null
  
)

export default component.exports